/**
 * SFrame183 — Financial institutions & insurers: freeze timelines, claims, and bulk updates.
 */

import { useParams, Navigate } from 'react-router-dom';
import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS.notify.steps.find((s) => s.id === 'not-2')!;

export default function SFrame183() {
  const { estateId } = useParams<{ estateId: string }>();

  // Guard: estateId is required for all save operations — redirect to estate
  // selector so the user re-enters via the proper route with an estateId.
  if (!estateId) return <Navigate to="/estate-selector" replace />;

  const overview = `/sframe-180/${estateId}`;

  return (
    <SettlementStepPage step={step} phase="notify" overviewRoute={overview} plannerFrameIds={['frame-186', 'frame-189']} />
  );
}
